import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowRightContained02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#000"
      d="M13.475 7.117a1 1 0 0 0-1.536 1.28l.768-.64zM16.243 12l.768.64a1 1 0 0 0 0-1.28zm-4.304 3.602a1 1 0 0 0 1.536 1.28l-.768-.64zM7.757 11a1 1 0 1 0 0 2v-2m4.95-3.243-.768.64 3.536 4.243.768-.64.768-.64-3.536-4.243zM16.243 12l-.768-.64-3.536 4.243.768.64.768.64 3.536-4.243zm0 0v-1H7.757v2h8.486zm2.545-6.788-.707.707a8.6 8.6 0 0 1 0 12.162l.707.707.707.707c4.14-4.14 4.14-10.85 0-14.99zm0 13.576-.707-.707a8.6 8.6 0 0 1-12.162 0l-.707.707-.707.707c4.14 4.14 10.85 4.14 14.99 0zm-13.576 0 .707-.707a8.6 8.6 0 0 1 0-12.162l-.707-.707-.707-.707c-4.14 4.14-4.14 10.85 0 14.99zm0-13.576.707.707a8.6 8.6 0 0 1 12.162 0l.707-.707.707-.707c-4.14-4.14-10.85-4.14-14.99 0z"
    />
  </svg>
);
export default SvgArrowRightContained02;
